import { useState } from 'react';
import EmailScreen from './EmailScreen';
import ResetPasswordScreen from './ResetPasswordScreen';
import { ResetScreens } from '../../../shared/constants/ResetPassword';

function ForgotPassword() {
  const [state, setState] = useState({
    currentScreen: ResetScreens.EMAIL_SCREEN,
    email: '',
  });

  function updateState(newState: Partial<typeof state>) {
    setState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  }

  return (
    <>
      {state.currentScreen === 1 && (
        <EmailScreen state={state} setState={updateState} />
      )}
      {state.currentScreen === 2 && (
        <ResetPasswordScreen state={state} setState={updateState} />
      )}
    </>
  );
}

export default ForgotPassword;
